var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnauthoraizIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 316,
    height: 316,
    viewBox: "0 0 316 316",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M215.714 252.66L52.6411 205.288L100.129 42.1327L263.202 89.5048L215.714 252.66ZM77.2901 191.773L202.345 228.138L238.692 103.02L113.637 66.6547L77.2901 191.773Z",
    fill: "#1E2D66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.061 133.116C166.138 133.116 172.405 139.386 172.405 147.467C172.405 155.548 166.138 161.818 158.061 161.818C149.984 161.818 143.717 155.548 143.717 147.467C143.857 139.386 150.123 133.116 158.061 133.116ZM148.174 171.989H167.948V263.808H148.174V171.989Z",
    fill: "#1E2D66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133.002 147.161L133 147.256V147.351C133 152.768 134.639 157.752 137.456 161.841V171.873V263.691V274.691H148.456H168.231H179.231V263.691V171.873V161.841C182.049 157.752 183.688 152.768 183.688 147.351C183.688 133.2 172.501 122 158.344 122C144.223 122 133.241 133.263 133.002 147.161Z",
    stroke: "white",
    strokeWidth: 22
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnauthoraizIcon);
export default __webpack_public_path__ + "static/media/unauthoraiz_icon.17bf55d8592759239f42fe0157282f22.svg";
export { ForwardRef as ReactComponent };